var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "retell-audio-test" },
    [
      _c(
        "div",
        { staticClass: "test-buttons" },
        [
          _c(
            "a-button",
            {
              staticClass: "test-button w-100",
              attrs: {
                type: _vm.isCalling ? "danger" : "primary",
                loading: _vm.isConnecting,
              },
              on: { click: _vm.toggleCall },
            },
            [
              _c("i", { staticClass: "material-icons" }, [
                _vm._v(_vm._s(_vm.isCalling ? "call_end" : "phone")),
              ]),
              _vm._v(
                "\n            " +
                  _vm._s(
                    _vm.isCalling
                      ? _vm.$t("voiceagent.endCall")
                      : _vm.$t("voiceagent.testAudio")
                  ) +
                  "\n        "
              ),
            ]
          ),
          _vm._v(" "),
          _c(
            "a-button",
            {
              staticClass: "variables-button",
              attrs: { type: "default", disabled: _vm.isCalling },
              on: { click: _vm.toggleVariablePopover },
            },
            [
              _c("i", { staticClass: "material-icons" }, [
                _vm._v("data_object"),
              ]),
            ]
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "a-popover",
        {
          attrs: {
            title: _vm.$t("voiceagent.customVariableValues"),
            trigger: "click",
            placement: "bottom",
            overlayClassName: "variable-values-popover",
          },
          model: {
            value: _vm.variablePopoverVisible,
            callback: function ($$v) {
              _vm.variablePopoverVisible = $$v
            },
            expression: "variablePopoverVisible",
          },
        },
        [
          _c("template", { slot: "content" }, [
            _vm.extractedVariables.length === 0
              ? _c("div", { staticClass: "no-variables" }, [
                  _vm._v(
                    "\n                " +
                      _vm._s(_vm.$t("voiceagent.promptNoVariablesHint")) +
                      "\n            "
                  ),
                ])
              : _c(
                  "div",
                  { staticClass: "variable-values-form" },
                  [
                    _vm._l(_vm.extractedVariables, function (variable, index) {
                      return _c(
                        "div",
                        { key: index, staticClass: "variable-row" },
                        [
                          _c("span", { staticClass: "variable-name" }, [
                            _vm._v(_vm._s(variable.name) + ":"),
                          ]),
                          _vm._v(" "),
                          _c("a-input", {
                            attrs: {
                              placeholder: _vm.$t("voiceagent.enterValue"),
                            },
                            model: {
                              value: variable.value,
                              callback: function ($$v) {
                                _vm.$set(variable, "value", $$v)
                              },
                              expression: "variable.value",
                            },
                          }),
                        ],
                        1
                      )
                    }),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "form-actions" },
                      [
                        _c(
                          "a-button",
                          {
                            attrs: { type: "primary" },
                            on: { click: _vm.saveVariableValues },
                          },
                          [_vm._v(_vm._s(_vm.$t("voiceagent.save")))]
                        ),
                      ],
                      1
                    ),
                  ],
                  2
                ),
          ]),
          _vm._v(" "),
          _c("template", { slot: "title" }, [
            _c("div", { staticClass: "popover-title" }, [
              _vm._v(_vm._s(_vm.$t("voiceagent.customVariableValues"))),
            ]),
          ]),
        ],
        2
      ),
      _vm._v(" "),
      _vm.callStatus
        ? _c("div", { staticClass: "call-status" }, [
            _c("span", { class: { "status-active": _vm.isCalling } }, [
              _vm._v(_vm._s(_vm.callStatus)),
            ]),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.transcript.length > 0 && _vm.isCalling
        ? _c("div", { staticClass: "transcript-container" }, [
            _c("h4", [
              _vm._v(_vm._s(_vm.$t("voiceagent.conversationTranscript"))),
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "transcript-content" },
              _vm._l(_vm.transcript, function (item, index) {
                return _c(
                  "div",
                  {
                    key: index,
                    staticClass: "transcript-item",
                    class: item.role,
                  },
                  [
                    _c("strong", [
                      _vm._v(
                        _vm._s(
                          item.role === "agent"
                            ? _vm.$t("voiceagent.agent")
                            : _vm.$t("voiceagent.user")
                        ) + ":"
                      ),
                    ]),
                    _vm._v(
                      "\n                " +
                        _vm._s(item.content) +
                        "\n            "
                    ),
                  ]
                )
              }),
              0
            ),
          ])
        : _vm._e(),
      _vm._v(" "),
      !_vm.isCalling
        ? _c("div", { staticClass: "test-logs" }, [
            _vm.logs.length === 0
              ? _c("p", { staticClass: "empty-logs" }, [
                  _vm._v(
                    _vm._s(_vm.$t("voiceagent.testResultsWillAppearHere"))
                  ),
                ])
              : _c(
                  "div",
                  { staticClass: "log-entries" },
                  _vm._l(_vm.logs, function (log, index) {
                    return _c("div", { key: index, staticClass: "log-entry" }, [
                      _vm._v(
                        "\n                " + _vm._s(log) + "\n            "
                      ),
                    ])
                  }),
                  0
                ),
          ])
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }